import React, {useEffect, useState} from 'react'
import LoadingOverlay from 'react-loading-overlay'
import { TablaUsuarios } from '../../components/TablaUsuarios/TablaUsuarios'
import {AdminTableSearch} from '../../components/AdminDataTable/AdminDataTable'
import axios from 'axios'

import './Distribuidores.css'
import { Modal } from 'react-bootstrap'
import { ModalDistribuidor } from '../../components/ModalDistribuidor/ModalDistribuidor'

function Distribuidores() {
  const API_URL = process.env.REACT_APP_API_URL

  const [spinnerIsActive, setSpinnerIsActive] = useState(false)

  const [usuarios, setUsuarios] = useState([])
  const [vendedores, setVendedores] = useState('')
  const [listasPrecios, setListasPrecios] = useState([])

  const [usuarioDetalle, setUsuarioDetalle] = useState(null)
  const [showModal, setShowModal] = useState(false)

  const [searchValue, setSearchValue] = useState('')

  const Usuarios = async () => {
    setSpinnerIsActive(true);
    try {
      const res = await axios.get(`${API_URL}/distribuidores`);
      setUsuarios(res.data)
    } catch (e) {
      console.error(e)
    } finally {
      setSpinnerIsActive(false)
    }
  }

  const getVendedores = () => {
    axios.get(API_URL + '/lista-vendedores').then((res) => {
      setVendedores(res.data);
    })
  }

  const getListasPrecios = () => {
    axios.get(API_URL + '/listas-precios').then((res) => setListasPrecios(res.data))
  }

  const mostrarUsuario = async (id) => {
    const res = await axios.get(`${API_URL}/distribuidores-detalle/${id}`)
    setUsuarioDetalle(res.data)
    setShowModal(true)
  }


  const actualizarUsuarioDetalle = async (id) => {
    const res = await axios.get(`${API_URL}/distribuidores-detalle/${id}`)
    setUsuarioDetalle(res.data)
    await Usuarios()
  }

  useEffect(() => {
    Usuarios()
    getVendedores()
    getListasPrecios()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const filteredUsuarios = usuarios.filter((u) =>
    Object.values(u).join(" ").toLowerCase().includes(searchValue.toLowerCase())
  );

  return (
    <>
      <LoadingOverlay active={spinnerIsActive} spinner text='Cargando...'>
        <Modal show={showModal} onHide={() => setShowModal(false)} dialogClassName="modal-distribuidor-dialog" centered>
          <Modal.Header closeButton>
            <Modal.Title>Detalle de Distribuidor</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {usuarioDetalle && <ModalDistribuidor usuario={usuarioDetalle} vendedores={vendedores} listasPrecios={listasPrecios} onClose={() => setShowModal(false)} onUpdated={actualizarUsuarioDetalle} />}
          </Modal.Body>
        </Modal>

        <div className='row g-5'>
          <div className='col-lg-12'>
            <div className='card card-custom card-stretch shadow mb-5 admin-list-card'>
              <div className='card-header'>
                <h3 className='card-title'>Distribuidores</h3>
              </div>
              <div className='card-body'>
                <AdminTableSearch value={searchValue} onChange={(event) => setSearchValue(event.target.value)} ariaLabel='Buscar distribuidores' />

                <div className='row px-6 pb-6'>
                  <TablaUsuarios usuarios={filteredUsuarios} mostrarUsuario={mostrarUsuario}/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LoadingOverlay>
    </>
  )
}

export {Distribuidores}
